import { PhotoHero } from "@/components/site/SiteLayout";
import heroImage from "@/assets/tayrona-hero.avif";
import { ENTRY_FEES, formatCOP } from "@/constants";
import { getParkStatus } from "@/lib/closures";

/**
 * Home hero (DESIGN.md): photo fading to white, frosted fact chips, then the
 * H1 at display size with the full keyword phrase on the second line.
 */
const Hero = () => {
  const { status, label, detail } = getParkStatus();
  // General (non Santa Marta-born) lowest fee, low season.
  const entradaDesde = ENTRY_FEES[0].lowSeasonCOP;

  return (
    <>
      <PhotoHero
        foto={{
          src: heroImage,
          alt: "Vista panorámica del Parque Nacional Natural Tayrona, Colombia",
        }}
        chips={
          <>
            <a href="#cierres" className="pq-chip pq-chip-frost" style={{ textDecoration: "none" }}>
              <span className={`pq-dot${status === "open" ? "" : " pq-dot-alert"}`} aria-hidden="true" />
              {label}. {detail}
            </a>
            <span className="pq-chip pq-chip-frost">Entrada desde {formatCOP(entradaDesde)}</span>
          </>
        }
      />

      <section className="pq-wrap pq-intro">
        <h1 className="pq-display pq-rise">
          Campings del Parque Tayrona.
        </h1>
        <p className="pq-lead pq-rise pq-rise-2">
          Guía para acampar en el Parque Nacional Natural Tayrona, cerca de Santa
          Marta: compara campamentos, precios y todo lo que necesitas antes de salir.
        </p>
        <a href="#campsites" className="pq-btn pq-btn-primary pq-rise pq-rise-3">
          Explorar campings
        </a>
      </section>
    </>
  );
};

export default Hero;
